<template>
    <div class="mt-8 flex justify-center">
        <nav class="flex items-center space-x-2">
            <button 
                @click="$emit('page-change', currentPage - 1)" 
                :disabled="currentPage === 1"
                class="foxy-btn-secondary !px-4 !py-2 !rounded-lg !text-base !font-normal"
            >
                Попередня
            </button>
            
            <span class="px-4 py-2 text-foxy-text-secondary">
                Сторінка {{ currentPage }} з {{ lastPage }}
            </span>
            
            <button 
                @click="$emit('page-change', currentPage + 1)" 
                :disabled="currentPage === lastPage"
                class="foxy-btn-secondary !px-4 !py-2 !rounded-lg !text-base !font-normal"
            >
                Наступна
            </button>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'NotificationPagination',
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        lastPage: {
            type: Number,
            required: true
        }
    },
    emits: ['page-change']
};
</script>
